/* eslint-disable */
export enum PublicationViewType {
  PUBLICATION,
  PENDING,
}
